/**
 * Carrusel de header
 * Controla: autoplay configurable, flechas, dots, pausa en hover.
 */
function initCarruselHeader(sectionId) {
  var root = document.getElementById('carrusel-header-' + sectionId);
  if (!root || root.dataset.carruselInit === 'true') return;
  root.dataset.carruselInit = 'true';

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-slide]'));
  if (slides.length < 1) return;

  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carrusel-dot]'));
  var prevBtn = root.querySelector('[data-carrusel-prev]');
  var nextBtn = root.querySelector('[data-carrusel-next]');

  var autoplay = root.dataset.autoplay === 'true';
  var velocidad = parseInt(root.dataset.velocidad, 10) || 5000;
  var pausarEnHover = root.dataset.pausarHover === 'true';
  var velocidadTransicion = parseInt(root.dataset.velocidadTransicion, 10) || 600;

  var indiceActual = 0;
  var timer = null;
  var pausado = false;

  // Aplicar velocidad de transición configurable
  slides.forEach(function(slide) {
    slide.style.transition = 'opacity ' + (velocidadTransicion / 1000) + 's var(--animation-timing-default, ease)';
  });

  function irA(indice) {
    if (indice < 0) indice = slides.length - 1;
    if (indice >= slides.length) indice = 0;

    slides[indiceActual].classList.remove('is-active');
    if (dots[indiceActual]) dots[indiceActual].classList.remove('is-active');

    indiceActual = indice;

    slides[indiceActual].classList.add('is-active');
    if (dots[indiceActual]) dots[indiceActual].classList.add('is-active');
  }

  function siguiente() {
    irA(indiceActual + 1);
  }

  function anterior() {
    irA(indiceActual - 1);
  }

  function iniciarAutoplay() {
    if (!autoplay || slides.length < 2) return;
    detenerAutoplay();
    timer = window.setInterval(function () {
      if (!pausado) siguiente();
    }, velocidad);
  }

  function detenerAutoplay() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      anterior();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      siguiente();
    });
  }

  dots.forEach(function (dot, idx) {
    dot.addEventListener('click', function () {
      irA(idx);
    });
  });

  if (pausarEnHover) {
    root.addEventListener('mouseenter', function () {
      pausado = true;
    });
    root.addEventListener('mouseleave', function () {
      pausado = false;
    });
  }

  // Soporte de gestos táctiles básicos (swipe)
  var touchStartX = 0;
  root.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  root.addEventListener('touchend', function (e) {
    var touchEndX = e.changedTouches[0].screenX;
    var diferencia = touchStartX - touchEndX;
    if (Math.abs(diferencia) > 40) {
      if (diferencia > 0) {
        siguiente();
      } else {
        anterior();
      }
    }
  }, { passive: true });

  iniciarAutoplay();
}
